import { IResponse } from "models";

export enum ActionType {
  DATA_PATIENT_CHILD_DEPARTMENT = "action/DATA_PATIENT_CHILD_DEPARTMENT",
  DATA_PATIENT_CHILD_DEPARTMENT_SUCCESS = "action/DATA_PATIENT_CHILD_DEPARTMENT_SUCCESS",
  DATA_PATIENT_CHILD_DEPARTMENT_ERROR = "action/DATA_PATIENT_CHILD_DEPARTMENT_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface DataPatientChildDepartmentResponse extends IResponse {
  result: any;
}
